
import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "../../Styles/Pagination.css";

const Pagination = ({ currentPage, totalPages, onPageChange, className = "" }) => {
  return (
    <div className={`pagination ${className}`}>
      <button 
        className="pagination-arrow" 
        onClick={() => onPageChange(currentPage - 1)} 
        disabled={currentPage === 1}
      >
        <ChevronLeft size={16} />
        <span>Previous</span>
      </button>
      
      <div className="pagination-pages">
        {Array.from({ length: totalPages }, (_, idx) => {
          const pageNum = idx + 1;
          
          if (
            pageNum === 1 || 
            pageNum === totalPages || 
            (pageNum >= currentPage - 1 && pageNum <= currentPage + 1)
          ) {
            return (
              <button
                key={pageNum}
                className={currentPage === pageNum ? "pagination-active" : ""}
                onClick={() => onPageChange(pageNum)}
              >
                {pageNum}
              </button>
            );
          } else if (
            pageNum === currentPage - 2 || 
            pageNum === currentPage + 2
          ) {
            return <span key={pageNum} className="pagination-ellipsis">...</span>;
          }
          return null;
        })}
      </div>
      
      <button 
        className="pagination-arrow" 
        onClick={() => onPageChange(currentPage + 1)} 
        disabled={currentPage === totalPages}
      >
        <span>Next</span>
        <ChevronRight size={16} />
      </button>
    </div>
  );
};

export default Pagination;
